import { Box } from "@mui/material";

// 一覧が空・未選択などのプレースホルダ表示。py は周辺レイアウトに合わせて上書き可。
export function EmptyState({ message, py = 6 }: { message: string; py?: number }) {
  return <Box sx={{ py: py, textAlign: "center", color: "text.secondary" }}>{message}</Box>;
}
